import { makePropCacheMixin } from '../utils/cache'

export default makePropCacheMixin('$listeners', 'bvListeners')
